import Duck from 'extensible-duck';
import Immutable from 'immutable';

export default new Duck({
  namespace: 'public',
  store: 'registration',
  types: [],
  initialState: Immutable.fromJS({
    $$programs: [],
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      default:
        return $$state;
    }
  },
  selectors: {
    $$activePrograms: $$state =>
      $$state.get('$$programs').filter($$program => $$program.get('is_active')),
  },
  creators: ({ types }) => ({}),
});
